import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import HandlerMailRegistrationDeviceDeliveryReport
  from '../../components/HandlerMailRegistrationDeviceDeliveryReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/HandlerMailRegistrationDeviceDeliverySummarySelectors';

export function HandlerMailRegistrationDeviceDeliverySummaryContainer(props) {
  return (
    <HandlerMailRegistrationDeviceDeliveryReport
      reportId={ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

HandlerMailRegistrationDeviceDeliverySummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(HandlerMailRegistrationDeviceDeliverySummaryContainer);
